import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/service',
    name: 'service',
    component: () => import('./pages/Service.vue')
  },
  {
    path: '/service/vehicle',
    name: 'service.vehicle',
    component: () => import('./pages/Vehicle.vue')
  },
  {
    path: '/service/calendar',
    name: 'service.calendar',
    component: () => import('./pages/Calendar.vue')
  },
  {
    path: '/service/summary',
    name: 'service.summary',
    component: () => import('./pages/Summary.vue')
  },
  {
    path: '/service/thankyou',
    name: 'service.thankyou',
    component: () => import('./pages/Thankyou.vue')
  }
];

const router = new VueRouter({
  mode: 'abstract',
  base: process.env.BASE_URL,
  routes,
});

export default router;
